<doka-number-input
  *ngIf="!isImperial; else imperialInput"
  [label]="label"
  [alert]="alert"
  [desc]="desc"
  [unit]="showUnit ? unit : ''"
  [disabled]="disabled"
  [required]="required"
  [step]="step"
  [value]="valueInUnit ? +valueInUnit : 0"
  (valueChange)="onValueChanged($event)"
  [showStep]="showStep">
</doka-number-input>

<ng-template #imperialInput>
  <doka-text-field
    [label]="label"
    [alert]="alert"
    [desc]="desc"
    [disabled]="disabled"
    [required]="required"
    [value]="'' + valueInUnit"
    (valueChange)="onValueChanged($event)">
  </doka-text-field>
</ng-template>
